// ------SAMPLE CALLS------

import { getBranch, getKey, getToken, getUser } from "../../Utilities/Common"
import {
  getAPICall,
  postAPICallwithFile,
  putAPICall,
  postAPICall,
  getWithParamsAPICall,
} from "../axiosMethodCall"

//POST API -- append a new data to the db
export const createCheckUp = async (data, patient_id, type) => {
  try {
    var formData = new FormData()
    formData.append("requester", getUser())
    formData.append("token", getToken())
    formData.append("patient_id", patient_id || "")
    formData.append(
      "is_surgical_outpatient",
      data?.is_surgical_outpatient || "0"
    )

    if (data?.is_surgical_outpatient === "1") {
      formData.append("procedure", data?.procedure || "")
      formData.append("pf", data?.pf || "")
      formData.append("notes", data?.notes || "")
    } else {
      formData.append("procedure", "")
      formData.append("pf", "")
      formData.append("notes", "")
    }

    formData.append("is_sunday_patient", data?.is_sunday_patient || "0")
    if (data.is_sunday_patient === "1") {
      formData.append("last_checkup_date", data?.last_checkup_date || "")
    } else {
      formData.append("last_checkup_date", "")
    }
    formData.append("doctor_id", data.doctor_id || "")
    formData.append("complaint", data.complaint || "")
    formData.append("subjective", data.subjective || "")
    formData.append("objective", data.objective || "")
    formData.append("plan", data.plan || "")

    // formData.append("checkup_note", data.checkup_note || "");
    // formData.append("illness_history", data.illness_history || "");
    // formData.append("general_survey", data.general_survey || "");
    // formData.append("heent", data.heent || "");
    // formData.append("cl", data.cl || "");
    // formData.append("cvs", data.cvs || "");
    // formData.append("abdomen", data.abdomen || "");
    // formData.append("skin", data.skin || "");
    // formData.append("extremities", data.extremities || "");
    // formData.append("neurologic", data.neurologic || "");
    // formData.append("pertinent_diagnostics", data.pertinent_diagnostics || "");
    // formData.append("diagnosis", data.diagnosis || "")
    data.diagnosis.map((info) => {
      formData.append("diagnosis[]", info.diagnosis_name)
    })
    formData.append("type", type || "")
    // formData.append("from_type", data?.from_type || "");

    const response = await postAPICallwithFile(
      process.env.REACT_APP_LINK + "assessments/create",
      formData
    )
    return response
  } catch (error) {
    return { error: error.response }
  }
}

// export const endConsultation = async (data) => {
//   try {
//     var formData = new FormData();
//     formData.append("requester", getUser());
//     formData.append("token", getToken());
//     formData.append("assessment_id", data.assessment_id);
//     formData.append("assessment_type", data.type);
//     formData.append("booking_id", data.booking_id);

//     const response = await postAPICallwithFile(
//       process.env.REACT_APP_LINK + "assessments/end",
//       formData
//     );
//     return { data: response.data };
//   } catch (error) {
//     return { error: error.response };
//   }
// };
export const endConsultation = async (data) => {
  try {
    var formData = new FormData();
    formData.append("requester", getUser());
    formData.append("token", getToken());
    formData.append("assessment_id", data.assessment_id);
    formData.append("assessment_type", data.type);
    formData.append("status", data.status);

    const response = await postAPICallwithFile(
      process.env.REACT_APP_LINK + "assessments/end",
      formData
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const updateCheckUp = async (data, patient_id) => {
  try {
    var formData = new FormData()
    formData.append("requester", getUser())
    formData.append("token", getToken())
    formData.append("patient_id", patient_id)
    formData.append("assessment_id", data.id)
    formData.append("is_surgical_outpatient", data.is_surgical_outpatient)
    formData.append("is_sunday_patient", data.is_sunday_patient)
    if (data?.is_surgical_outpatient === "1") {
      formData.append("procedure", data?.procedure || "")
      formData.append("pf", data?.pf || "")
      formData.append("notes", data?.notes || "")
    } else {
      formData.append("procedure", "")
      formData.append("pf", "")
      formData.append("notes", "")
    }
    if (data.is_sunday_patient === "1") {
      formData.append("last_checkup_date", data?.last_checkup_date || "")
    } else {
      formData.append("last_checkup_date", "")
    }
    formData.append("doctor_id", data.doctor_id || "")
    formData.append("complaint", data.complaint)
    formData.append("subjective", data.subjective || "")
    formData.append("objective", data.objective || "")
    formData.append("plan", data.plan || "")
    // formData.append("checkup_note", data.checkup_note || "");
    // formData.append("illness_history", data.illness_history || "");
    // formData.append("general_survey", data.general_survey || "");
    // formData.append("heent", data.heent || "");
    // formData.append("cl", data.cl || "");
    // formData.append("cvs", data.cvs || "");
    // formData.append("abdomen", data.abdomen || "");
    // formData.append("skin", data.skin || "");
    // formData.append("extremities", data.extremities || "");
    // formData.append("neurologic", data.neurologic || "");
    // formData.append("pertinent_diagnostics", data.pertinent_diagnostics || "");
    // formData.append("diagnosis", data.diagnosis || "")
    formData.append("type", data.type || "")
    formData.append("from_type", data?.from_type || "")
    data.diagnosis.map((info) => {
      formData.append("diagnosis_ids[]", info?.id || "")
      formData.append("diagnosis[]", info.diagnosis_name)
    })

    const response = await postAPICallwithFile(
      process.env.REACT_APP_LINK + "assessments/update",
      formData
    )
    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

export const createAdmission = async (
  data,
  patient_id,
  assessment_id,
  doctor_id
) => {
  try {
    var formData = new FormData()
    formData.append("requester", getUser())
    formData.append("token", getToken())
    formData.append("patient_id", patient_id)
    formData.append("doctor_id", doctor_id)
    formData.append("assessment_id", assessment_id)
    formData.append("problem", data?.problem || "")
    formData.append("health_condition", data?.health_condition || "")
    formData.append("vital_signs", data?.vital_signs || "")
    formData.append("ambulation", data?.ambulation || "")
    formData.append("iso_precaution", data?.iso_precaution || "")
    formData.append("diet", data?.diet || "")
    formData.append("ivf", data?.ivf || "")
    formData.append("tpr", data?.tpr || "")
    formData.append("i_and_o", data?.i_and_o || "")
    formData.append("plan", data?.plan || "")
    formData.append("labs", data?.labs || "")
    formData.append("xray", data?.xray || "")
    formData.append("treatment", data?.treatment || "")

    const response = await postAPICallwithFile(
      process.env.REACT_APP_LINK + "inpatients/create",
      formData
    )
    return response
  } catch (error) {
    return error
  }
}
export const updateAdmission = async (data) => {
  try {
    var formData = new FormData()
    formData.append("requester", getUser())
    formData.append("token", getToken())
    formData.append("inpatient_id", data.id)
    formData.append("patient_id", data.patient_id)
    formData.append("doctor_id", data.doctor_id)
    formData.append("assessment_id", data.assessment_id)
    formData.append("problem", data.problem)
    formData.append("health_condition", data.health_condition)
    formData.append("vital_signs", data.vital_signs)
    formData.append("ambulation", data.ambulation)
    formData.append("iso_precaution", data.iso_precaution)
    formData.append("diet", data.diet)
    formData.append("ivf", data.ivf)
    formData.append("tpr", data.tpr)
    formData.append("i_and_o", data.i_and_o)
    formData.append("plan", data.plan)
    formData.append("labs", data.labs)
    formData.append("xray", data.xray)
    formData.append("treatment", data.treatment)

    const response = await postAPICallwithFile(
      process.env.REACT_APP_LINK + "inpatients/update",
      formData
    )
    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

export const updateOutPatient = async (
  data,
  patient_id,
  assessment_id,
  outpatient_id,
  doctor_id
) => {
  try {
    var formData = new FormData()
    formData.append("requester", getUser())
    formData.append("token", getToken())
    formData.append("patient_id", patient_id)
    formData.append("doctor_id", data.doctor_id)
    formData.append("assessment_id", assessment_id)
    formData.append("outpatient_id", data.id || outpatient_id)
    formData.append("followup_on", data.followup_on || "")
    formData.append("professional_fee", data.professional_fee || null)
    formData.append("sales_invoice_no", data.sales_invoice_no || "")
    formData.append("professional_fee_method", data.professional_fee_method)
    formData.append(
      "corporate_type",
      data.professional_fee_method === "corporate" ? data.corporate_type : ""
    )
    formData.append(
      "corporate_id",
      data.professional_fee_method === "corporate" ? data.corporate_id : ""
    )
    formData.append(
      "hmo_type",
      data.professional_fee_method === "hmo" ? data.hmo_type : ""
    )
    formData.append(
      "hmo_id",
      data.professional_fee_method === "hmo" ? data.hmo_id : ""
    )
    formData.append("reference_no", data?.reference_no || "")
    // formData.append("plan", data.plan || "")

    const response = await postAPICallwithFile(
      process.env.REACT_APP_LINK + "outpatients/update",
      formData
    )
    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}
export const createOutPatient = async (
  data,
  patient_id,
  assessment_id,
  doctor_id
) => {
  try {
    var formData = new FormData()
    formData.append("requester", getUser())
    formData.append("token", getToken())
    formData.append("patient_id", patient_id)
    formData.append("doctor_id", data.doctor_id)
    formData.append("assessment_id", assessment_id)
    formData.append("followup_on", data.followup_on || "")
    formData.append("professional_fee", data.professional_fee || null)
    formData.append("sales_invoice_no", data.sales_invoice_no || "")
    formData.append("professional_fee_method", data.professional_fee_method)
    formData.append(
      "corporate_type",
      data.professional_fee_method === "corporate" ? data?.corporate_type : ""
    )
    formData.append(
      "corporate_id",
      data.professional_fee_method === "corporate" ? data?.corporate_id : ""
    )
    formData.append(
      "hmo_type",
      data.professional_fee_method === "hmo" ? data?.hmo_type : ""
    )
    formData.append(
      "hmo_id",
      data.professional_fee_method === "hmo" ? data?.hmo_id : ""
    )
    formData.append("reference_no", data?.reference_no || "")
    // formData.append("plan", data.plan || "")

    const response = await postAPICallwithFile(
      process.env.REACT_APP_LINK + "outpatients/create",
      formData
    )
    return response
  } catch (error) {
    return { error: error.response }
  }
}

export const getOutPatient = async (id, page) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken()?.replace(/['"]+/g, ""),
      outpatient_id: id,
      page: page,
    }

    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "outpatients/get",
      payload
    )

    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

//POST API -- append a new data to the db
export const createDiagnostic = async (
  info,
  diagnostics,
  patient_id,
  assessment_id
) => {
  try {
    var formData = new FormData()
    formData.append("requester", getUser())
    formData.append("token", getToken()?.replace(/['"]+/g, ""))
    formData.append("patient_id", patient_id)
    formData.append("assessment_id", assessment_id)
    formData.append("fasting", info.fasting)
    formData.append("others", info.others)
    diagnostics.map((data) => {
      formData.append("type[]", data.type)
    })
    diagnostics.map((data) => {
      formData.append("lab_name[]", data.lab_name)
    })
    diagnostics.map((data) => {
      formData.append(
        "lab_schedule[]",
        data.lab_schedule ? data.lab_schedule.split("T").join(" ") + ":00" : ""
      )
    })
    const response = await postAPICallwithFile(
      process.env.REACT_APP_LINK + "diagnostics/create",
      formData
    )
    return response
  } catch (error) {
    return { error: error.response }
  }
}

export const updateDiagnostic = async (
  info,
  diagnostics,
  patient_id,
  assessment_id
) => {
  try {
    var formData = new FormData()
    formData.append("requester", getUser())
    formData.append("token", getToken().replace(/['"]+/g, ""))
    formData.append("diagnostic_id", info.id)
    formData.append("patient_id", patient_id)
    formData.append("assessment_id", assessment_id)
    formData.append("fasting", info.fasting)
    formData.append("others", info.others)
    diagnostics.map((data) => {
      formData.append("type[]", data.type)
    })
    diagnostics.map((data) => {
      formData.append("lab_name[]", data.lab_name)
    })
    diagnostics.map((data) => {
      formData.append(
        "lab_schedule[]",
        data.lab_schedule ? data.lab_schedule.split("T").join(" ") + ":00" : ""
      )
    })

    // file.map((val) => {
    //     formData.append("attachments[]", val);
    // });
    const response = await postAPICallwithFile(
      process.env.REACT_APP_LINK + "diagnostics/update",
      formData
    )

    return { data: response }
  } catch (error) {
    return { data: error.response.data }
  }
}
export const getDiagnostic = async (id) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken()?.replace(/['"]+/g, ""),
      diagnostic_id: id,
    }

    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "diagnostics/get",
      payload
    )
    return { data: response.data.data }
  } catch (error) {
    return { error: error.response }
  }
}

//POST API -- append a new data to the db
export const createTherapeutic = async (info, patient_id, assessment_id) => {
  try {
    var formData = new FormData()
    formData.append("requester", getUser())
    formData.append("token", getToken()?.replace(/['"]+/g, ""))
    formData.append("patient_id", patient_id)
    formData.append("assessment_id", assessment_id)
    info.forEach((data) => {
      formData.append("medicine_id[]", data.medicine_id ? data.medicine_id : "")
      formData.append("generic[]", data.generic ? data.generic : "")
      formData.append("brand[]", data.brand ? data.brand : "")
      formData.append("dosage[]", data.dosage ? data.dosage : "")
      formData.append("preparation[]", data.preparation ? data.preparation : "")
      formData.append("quantity[]", data.quantity ? data.quantity : "")
      formData.append("duration[]", data.duration ? data.duration : "")
      formData.append("instruction[]", data.instruction ? data.instruction : "")
      formData.append("note[]", data.note ? data.note : "")
      // formData.append("form[]", data.form ? data.form : "")
      // formData.append("route[]", data.route ? data.route : "")
      // formData.append("frequency[]", data.frequency ? data.frequency : "")
      // formData.append("timing[]", data.timing ? data.timing : "")
    })
    const response = await postAPICallwithFile(
      process.env.REACT_APP_LINK + "therapeutics/create_multiple",
      formData
    )
    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

export const getTherapeutics = async (data) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken()?.replace(/['"]+/g, ""),
      ...data,
    }

    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "therapeutics/get",
      payload
    )
    return { data: response.data.data }
  } catch (error) {
    return { error: error.response }
  }
}

export const getTherapeutic = async (data) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken()?.replace(/['"]+/g, ""),
      ...data,
    }

    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "prescriptions/get",
      payload
    )
    return { data: response.data.data }
  } catch (error) {
    return { error: error.response }
  }
}

export const getAutoSuggestTherapeutics = async (data) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken()?.replace(/['"]+/g, ""),
      ...data,
    }

    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "auto_suggests/execute",
      payload
    )
    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

export const updateTherapeutic = async (
  info,
  patient_id,
  assessment_id,
  therapeutic_id
) => {
  try {
    var formData = new FormData()
    formData.append("requester", getUser())
    formData.append("token", getToken().replace(/['"]+/g, ""))
    formData.append("patient_id", patient_id)
    formData.append("assessment_id", assessment_id)
    // formData.append("therapeutic_id", therapeutic_id);s
    formData.append("therapeutic_id", info.id)
    formData.append("generic", info.generic ? info.generic : "")
    formData.append("brand", info.brand ? info.brand : "")
    formData.append("dosage", info.dosage ? info.dosage : "")
    formData.append("preparation", info.preparation ? info.preparation : "")
    formData.append("quantity", info.quantity ? info.quantity : "")
    formData.append("duration", info.duration ? info.duration : "")
    formData.append("instruction", info.instruction ? info.instruction : "")
    formData.append("note", info.note ? info.note : "")
    // formData.append("form", info.form ? info.form : "");
    // formData.append("route", info.route ? info.route : "");
    // formData.append("frequency", info.frequency ? info.frequency : "");
    // formData.append("timing", info.timing ? info.timing : "");

    const response = await postAPICallwithFile(
      process.env.REACT_APP_LINK + "therapeutics/update",
      formData
    )

    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

export const deleteTherapeutic = async (id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "therapeutics/delete",
      {
        requester: getUser(),
        token: getToken()?.replace(/['"]+/g, ""),
        therapeutic_id: id,
      }
    )
    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

export const getAdmission = async (data) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      ...data,
    }

    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "inpatients/get",
      payload
    )
    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

export const refuseAdmission = async (data) => {
  try {
    var formData = new FormData()
    formData.append("requester", getUser())
    formData.append("token", getToken())
    formData.append("assessment_id", data.assessment_id)
    formData.append("reason", data.reason)

    const response = await postAPICallwithFile(
      process.env.REACT_APP_LINK + "assessments/refuse_admission",
      formData
    )
    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}
